"use client";
import { ArrowRight } from "@/components/icons/ArrowRight";
import { ChevronUp } from "@/components/newIcons/ChevronUp";
import clsx from "clsx";
import Link from "next/link";
import { Fragment, useState } from "react";
import { SecondaryButton } from "ui/components";
import type { ReplayYurplanConferences } from "../../getReplayYurplanConferences";
import { ConferenceSolo } from "./ConferenceSolo";

type Props = {
  conference: ReplayYurplanConferences["conferences"][number];
};
export const ConferenceCycle = ({ conference }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={clsx(
        "bg-[rgba(100,97,94,0.16)] border border-[#6D6662] rounded-lg px-4 pt-4 pb-3 flex flex-col gap-3",
        {
          "group cycle-open": open,
        },
      )}
    >
      <ConferenceSolo conference={conference} />
      <div
        className={clsx("grid transition-all duration-200", {
          "grid-rows-[0fr]": !open,
          "grid-rows-[1fr]": open,
        })}
      >
        <div className="overflow-hidden">
          <div className="border-l border-pr-1 ml-2 lg:ml-3">
            <div className="flex flex-col gap-3">
              {conference.childConferences.map((conference) => (
                <Fragment key={conference.id}>
                  <div className="ml-4 lg:ml-5 w-full h-px bg-[#64615E]/32" />
                  <div className="ml-4 lg:ml-5 flex flex-col lg:flex-row lg:items-center gap-6 py-2">
                    <div className="flex flex-col gap-3">
                      <p className="text-[#FCF6F0] text-base leading-5 font-semibold lg:line-clamp-1 lg:h-5">
                        {conference.title}
                      </p>
                      <p className="text-[#C1B1AC] text-base font-light line-clamp-2 h-12">{conference.description}</p>
                    </div>
                    <div>
                      <Link href={`/conferenciers/conference/y-${conference.id}-${conference.slug}`}>
                        <SecondaryButton className="w-full">
                          Accéder ({conference.price}€) <ArrowRight />
                        </SecondaryButton>
                      </Link>
                    </div>
                  </div>
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
      <svg height="1" width="100%" viewBox="0 0 12 1" preserveAspectRatio="none">
        <path
          d="M0 0 l12 0"
          stroke="#64615E"
          strokeOpacity={0.32}
          strokeWidth="1"
          strokeDasharray="8,8"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      <div
        className="flex justify-center items-center gap-1.5 text-[#C1B1AC] text-sm cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        Voir les {conference.childConferences.length} épisodes disponibles !
        <ChevronUp
          className={clsx("w-4 h-4", {
            "rotate-180": !open,
          })}
        />
      </div>
    </div>
  );
};
